<template>
    <div class="vert-carousel" :style='{height: cptLineHeight * lineCount + "rem"}'>
        <div class="carousel-list" ref='list'>
            <div class="carousel-item"
                :class='{prime: i % 3 === (cptNum + 1) % 3}'
                v-for='(item, i) in cptList' 
                :key='i'
                :style='{lineHeight: cptLineHeight + "rem", fontSize: fontSize + "rem"}'
                :index-num='i'
            >{{item}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['list', 'lineHeight', 'lineCount', 'fontSize', 'autoplayDelay' ],
    data(){
        return {
            centerNum: ((this.lineCount + 1) + (this.lineCount * 2)) / 2,
            addNum: this.lineCount - (((this.lineCount + 1) + (this.lineCount * 2)) / 2) + 1
        }
    },
    changeNum: 0,
    computed: {
        cptList(){
            const result = []
            for (var i = 1; i <= 3; i ++) {
                this.list.forEach(item => {
                    result.push(item)
                })
            }
            return result
        },
        cptLineHeight(){
            return this.lineHeight * this.fontSize
        },
        cptNum(){
            return this.centerNum + this.addNum
        }
    },
    created(){
        const self = this
        setInterval(() => {
            self.addNum ++
        }, this.autoplayDelay)


        this.$nextTick(()=> {
            this.$refs.list.addEventListener('transitionend', e => {
                if (self.cptNum === self.lineCount * 2) {
                    const el = e.currentTarget
                    setTimeout(() => {
                        el.classList.add('quick')
                        el.style.transform = 'translateY(-' + ((this.cptLineHeight * this.addNum)) + 'rem)'
                        self.addNum = this.lineCount - (((this.lineCount + 1) + (this.lineCount * 2)) / 2)
                        setTimeout(() => {
                            el.classList.remove('quick')
                        }, 50)
                    }, 100)
                }
            })
        })
    },
    watch: {
        cptNum(n) {
            const self = this
            this.$refs.list.style.transform = 'translateY(-' + ((this.cptLineHeight * n)) + 'rem)'
        }
    }
}
</script>

<style>
    .vert-carousel { overflow-y: hidden; padding-top: .6rem; }

    .vert-carousel .carousel-list { transition: transform .5s; }
    .vert-carousel .carousel-list.quick { transition: none;}

    .vert-carousel .carousel-list .carousel-item { white-space: nowrap; transition: all .2s; transform-origin: left center; opacity: .6; color: #272727; }
    .vert-carousel .carousel-list .carousel-item.prime { font-size: 2.2rem !important; font-weight: 500; opacity: 1; }
</style>
